import React from 'react'
// components
import MenuItem from '@mui/material/MenuItem'
// constants
import { ENTITIES } from 'constants/entities'
// icons
import UserIcon from '@mui/icons-material/Person'
import PositionIcon from '@mui/icons-material/Group'
// views
import {
  EntityText,
  IconWrapper,
  LabelWrapper,
  ChildrenWrapper,
  BusinessUnitsIcon,
  BusinessActivityIcon,
  BusinessProcessesIcon
} from './views'
// types
import { OptionProps } from 'react-select'

const EntityOption: React.FC<OptionProps<any>> = (props) => {
  return (
    // the option's value, same as the shared Option stamps — lets E2E tests pick an option by id
    <div data-entity-id={props.data.value}>
      {/* @ts-ignore */}
      <MenuItem
        component={'div'}
        buttonRef={props.innerRef}
        selected={props.isFocused}
        style={{ fontWeight: props.isSelected ? 500 : 400 }}
        {...props.innerProps}>
        <ChildrenWrapper entity={props.data.entity}>
          <IconWrapper>{getIconByEntity(props.data.entity)}</IconWrapper>
          <LabelWrapper>{props.children}</LabelWrapper>
          <EntityText>{props.data.entity?.split('_').join(' ').toLowerCase()}</EntityText>
        </ChildrenWrapper>
      </MenuItem>
    </div>
  )
}

const getIconByEntity = (entity: string) => {
  switch (entity) {
    case ENTITIES.USER:
      return <UserIcon />
    case ENTITIES.POSITION:
      return <PositionIcon />
    case ENTITIES.BUSINESS_ACTIVITY:
      return <BusinessActivityIcon />
    case ENTITIES.BUSINESS_PROCESS:
      return <BusinessProcessesIcon />
    case ENTITIES.BUSINESS_UNIT:
      return <BusinessUnitsIcon />
    default:
      return null
  }
}

export default EntityOption
